export default {
  header: {
    title: 'JOIN OUR TEAM',
    subtitle: "We greatly believe that human resources is the most valuable asset. At Silverman, we provide endless opportunities to unfold your skills and overcome your limits."
  },
  description: {
    title: 'WHY SILVERMAN?',
    subtitle: 'Working at Silverman is more than just a job. You can make a difference in the quality of lives of millions of residents in the world by our platforms and explore your passions with the coolest innovative property management technology.'
  },
  benefits: {
    title: '4 Competitive Benefits',
    benefit_list: [
      {
        title: 'Minimum 7 days annual holidays',
      },
      {
        title: 'Unlimited drinks and snacks',
      },
      {
        title: 'Unlimited drinks and snacks',
      },
      {
        title: 'Guarantee salary raise after 1 year',
      }
    ]
  },
  filter_list: ['All', 'Engineering', 'Sale', 'Customer Service'],
  job_openings: [
    {
      title: 'Front End Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 0
    },
    {
      title: 'Back End Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 1
    },
    {
      title: 'Full-stack Developer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 2
    },
    {
      title: 'UX/UI Designer',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 3,
    },
    {
      title: 'Software Tester',
      subtitle: 'Engineering',
      status: 'Full time',
      id: 4
    },
    {
      title: 'Sale Representative',
      subtitle: 'Sale',
      status: 'Full time',
      id: 5
    },
    {
      title: 'Customer Service',
      subtitle: 'Customer Service',
      status: 'Full time',
      id: 6
    }
  ]
}